import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-back-up', 'IconArrowBackUp', [
  ['path', { d: 'M9 14l-4 -4l4 -4', key: 'svg-0' }],
  ['path', { d: 'M5 10h11a4 4 0 1 1 0 8h-1', key: 'svg-1' }],
]);
